import React from 'react'

const ChevronDown10pxSvg = (props) => {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" width="11" height="6" viewBox="0 0 11 6" fill="none">
            <path d="M5.4248 5.87444C5.30522 5.87444 5.18953 5.85202 5.07772 5.80717C4.96531 5.76233 4.87174 5.70254 4.797 5.6278L0.671441 1.50224C0.507017 1.33782 0.424805 1.12855 0.424805 0.874439C0.424805 0.620328 0.507017 0.411061 0.671441 0.246636C0.835866 0.0822119 1.04513 0 1.29924 0C1.55335 0 1.76262 0.0822119 1.92705 0.246636L5.4248 3.74439L8.92256 0.246636C9.08699 0.0822119 9.29625 0 9.55037 0C9.80448 0 10.0137 0.0822119 10.1782 0.246636C10.3426 0.411061 10.4248 0.620328 10.4248 0.874439C10.4248 1.12855 10.3426 1.33782 10.1782 1.50224L6.05261 5.6278C5.96292 5.71749 5.86576 5.78087 5.76113 5.81794C5.65649 5.8556 5.54439 5.87444 5.4248 5.87444Z" fill="#404040" />
        </svg>
    )
}

export default ChevronDown10pxSvg